import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import InclusionsTable from './InclusionsTable'
import DiveInclusions from './DiveInclusions'
import ToggleInclusions from './ToggleInclusions'
import get from 'lodash/get'
import filter from 'lodash/filter'
import { useSelector } from 'react-redux'

export const getTitle = (guestType) => {
  if(guestType === 'diver') {
    return <FormattedMessage id='diver' defaultMessage='Diver' />
  } else if(guestType === 'nonDiver') {
    return <FormattedMessage id='non_diver' defaultMessage='Non diver' />
  }
  return <FormattedMessage id='student' defaultMessage='Student' />
}

export const getGuestName = (index) => {
  const guests = useSelector((state) => state.guestsList)
  if(!get(guests, 'length')) {
    return null
  }
  const currentGuests = guests[index]

  if(currentGuests.firstName || currentGuests.lastName) {
    return `${currentGuests.firstName} ${currentGuests.lastName}`
  }

  return null
}
// No need to show mandatory or included in price items.
export const sectionWithoutMandatoryOrIncluded = (items) => {
  return filter(items, (item) => !item.isMandatory && !item.isIncluded)
}

export default function ResortGuestInclusions({
  fields,
  resortData,
  guestType,
  isFixedPackage,
  totalGuests = 0,
}) {
  if(!fields.length) {
    return null
  }
  const isDiver = guestType === 'diver'
  const isStudent = guestType === 'student'
  return fields.map((name, index) => {
    const currentGuest = fields.value[index]
    const maxDives = get(currentGuest, 'diveInclusions.quantity')
    const rentalEquipmentCleared = sectionWithoutMandatoryOrIncluded(
      currentGuest.rentalEquipment
    )
    const extras = sectionWithoutMandatoryOrIncluded(currentGuest.extras)
    const isCoursesAvailable =
      currentGuest.courses && !!currentGuest.courses.length && !isStudent
    const noItems =
      !extras?.length && !rentalEquipmentCleared?.length && !isCoursesAvailable

    return (
      <div key={index}>
        <h4 className='subtitle'>
          {getGuestName(index + totalGuests) || (
            <Fragment>
              {getTitle(guestType)} {index + 1}
            </Fragment>
          )}
        </h4>
        <InclusionsTable>
          {isDiver && (
            <Fragment>
              {!isFixedPackage && (
                <DiveInclusions
                  name={`${name}.diveInclusions`}
                  item={{
                    key: index,
                    ...currentGuest.diveInclusions,
                  }}
                  diveType={resortData.diveType}
                  diveProducts={resortData.diveProducts}
                />
              )}
            </Fragment>
          )}
          {isStudent && <ToggleInclusions isStudent />}
          {rentalEquipmentCleared && !!rentalEquipmentCleared.length && (
            <ToggleInclusions
              name={`${name}.rentalEquipment`}
              maxDives={maxDives}
              sectionTitle={
                <FormattedMessage
                  id='add_rental_equipment'
                  defaultMessage='Add some rental equipment'
                />
              }
            />
          )}
          {extras && !!extras.length && (
            <ToggleInclusions
              name={`${name}.extras`}
              sectionTitle={
                <FormattedMessage
                  id='add_other_options'
                  defaultMessage='Add other dive options'
                />
              }
            />
          )}
          {isCoursesAvailable && (
            <ToggleInclusions
              name={`${name}.courses`}
              sectionTitle={
                <FormattedMessage
                  id='add_a_course'
                  defaultMessage='Add a course'
                />
              }
            />
          )}
          {noItems && !isStudent && <ToggleInclusions isStudent />}
        </InclusionsTable>
      </div>
    )
  })
}
